const readonlyProps = {
  readonlyKey: {
    type: Boolean,
    required: false,
    default: false
  },
  readonlyType: {
    type: Boolean,
    required: false,
    default: false
  },
  readonlyValue: {
    type: Boolean,
    required: false,
    default: false
  },
  disableAdd: {
    type: Boolean,
    required: false,
    default: false
  },
  disableRemove: {
    type: Boolean,
    required: false,
    default: false
  }
}

export default readonlyProps
